var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isInitial || _vm.isSaving
      ? _c("div", [
          _c("div", { staticClass: "dropbox" }, [
            _c("input", {
              staticClass: "input-file",
              attrs: {
                type: "file",
                multiple: _vm.multiple,
                name: _vm.uploadFieldName,
                disabled: _vm.isSaving,
                accept: "image/png,image/jpeg,image/jpg"
              },
              on: {
                change: function($event) {
                  _vm.filesChange($event.target.name, $event.target.files)
                  _vm.fileCount = $event.target.files.length
                }
              }
            }),
            _vm._v(" "),
            _vm.isInitial
              ? _c("p", [
                  _vm._v("\n                Sleep een foto hier "),
                  _c("br"),
                  _vm._v("of klik om een foto te selecteren"),
                  _c("br"),
                  _vm._v(
                    "\n                (jpg of png, max. 4MB)\n            "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isSaving
              ? _c("p", [
                  _vm._v(
                    "\n                " + _vm._s(_vm.fileCount) + " foto"
                  ),
                  _vm.fileCount > 1 ? _c("span", [_vm._v("'s")]) : _vm._e(),
                  _vm._v(" aan het versturen ...\n            ")
                ])
              : _vm._e()
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isSuccess
      ? _c("div", [
          _c(
            "ul",
            { staticClass: "list-unstyled" },
            _vm._l(_vm.uploadedFiles, function(item) {
              return _c("li", [
                _c("img", {
                  staticClass: "img-responsive img-thumbnail",
                  attrs: { src: item.url, alt: item.originalName }
                })
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n            " + _vm._s(_vm.uploadedFiles.length) + " foto"
            ),
            _vm.fileCount > 1 ? _c("span", [_vm._v("'s")]) : _vm._e(),
            _vm._v(" toegevoegd."),
            _c("br"),
            _c(
              "a",
              {
                staticClass: "link",
                attrs: { href: "javascript:void(0)" },
                on: {
                  click: function($event) {
                    return _vm.reset()
                  }
                }
              },
              [_vm._v("Klik hier om opnieuw te starten.")]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isFailed
      ? _c("div", [
          _c("p", { staticClass: "error" }, [
            _vm._v("\n            Fout: " + _vm._s(_vm.uploadError) + " "),
            _c("br"),
            _c(
              "a",
              {
                staticClass: "link",
                attrs: { href: "javascript:void(0)" },
                on: {
                  click: function($event) {
                    return _vm.reset()
                  }
                }
              },
              [_vm._v("Klik hier om opnieuw te starten.")]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }